// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.cn-ai-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 9998;
  pointer-events: none;
}
.cn-ai-sidebar--open {
  pointer-events: all;
}
.cn-ai-sidebar--open .cn-ai-sidebar__panel {
  transform: translateX(0);
}
.cn-ai-sidebar--open .cn-ai-sidebar__overlay {
  opacity: 1;
  pointer-events: all;
}
.cn-ai-sidebar__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}
.cn-ai-sidebar__panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 420px;
  max-width: 90vw;
  height: 100%;
  background: #fff;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  transform: translateX(100%);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  z-index: 1;
}
.cn-ai-sidebar__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid #e7eaec;
  background: #f1f1f2;
  flex-shrink: 0;
}
.cn-ai-sidebar__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.cn-ai-sidebar__title i {
  color: #6d6e71;
}
.cn-ai-sidebar__step-badge {
  font-size: 11px;
  background: #f1f1f2;
  color: #676a6c;
  padding: 3px 10px;
  border-radius: 3px;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid #ddd;
}
.cn-ai-sidebar__close {
  margin-left: auto;
  background: none;
  border: none;
  font-size: 18px;
  color: #ccc;
  cursor: pointer;
  padding: 4px 8px;
  transition: color 0.3s ease;
}
.cn-ai-sidebar__close:hover {
  color: #6d6e71;
}
.cn-ai-sidebar__section {
  padding: 16px 20px;
  border-bottom: 1px solid #e7eaec;
}
.cn-ai-sidebar__label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #676a6c;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.cn-ai-sidebar__prompt {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #6d6e71;
  resize: vertical;
  min-height: 80px;
  transition: border-color 0.3s ease;
}
.cn-ai-sidebar__prompt:focus {
  border-color: #6d6e71;
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
}
.cn-ai-sidebar__actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.cn-ai-sidebar__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border: none;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.cn-ai-sidebar__btn--generate {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
.cn-ai-sidebar__btn--generate:hover:not(:disabled) {
  background-color: #6d6e71;
}
.cn-ai-sidebar__btn--generate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.cn-ai-sidebar__btn--add {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
.cn-ai-sidebar__btn--add:hover {
  background-color: #6d6e71;
}
.cn-ai-sidebar__btn--regen {
  background-color: transparent;
  color: #676a6c;
  border: 1px solid #ddd;
}
.cn-ai-sidebar__btn--regen:hover {
  background-color: #f1f1f2;
}
.cn-ai-sidebar__error {
  padding: 12px 20px;
  background: #fff3f3;
  color: #ff485c;
  font-size: 13px;
  border-bottom: 1px solid #fdd;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.cn-ai-sidebar__error i {
  margin-right: 6px;
}
.cn-ai-sidebar__loading {
  padding: 40px 20px;
  text-align: center;
  color: #ccc;
}
.cn-ai-sidebar__loading p {
  margin-top: 12px;
  font-size: 13px;
  color: #676a6c;
}
.cn-ai-sidebar__loading-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
}
.cn-ai-sidebar__loading-dots span {
  width: 8px;
  height: 8px;
  background: #6d6e71;
  border-radius: 50%;
  animation: cn-ai-dot-pulse 1.2s ease infinite;
}
.cn-ai-sidebar__loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.cn-ai-sidebar__loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.cn-ai-sidebar__results-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.cn-ai-sidebar__select-all {
  background: none;
  border: none;
  color: #676a6c;
  font-size: 12px;
  cursor: pointer;
  padding: 2px 6px;
  font-weight: 700;
}
.cn-ai-sidebar__select-all:hover {
  text-decoration: underline;
}
.cn-ai-sidebar__results {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.cn-ai-sidebar__result {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 13px;
  line-height: 1.5;
  color: #6d6e71;
}
.cn-ai-sidebar__result:hover {
  border-color: #6d6e71;
  background: #f1f1f2;
}
.cn-ai-sidebar__result--selected {
  border-color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.06);
}
.cn-ai-sidebar__result input[type=checkbox] {
  margin-top: 2px;
  flex-shrink: 0;
  accent-color: rgb(105, 190, 40);
}
.cn-ai-sidebar__result-text {
  flex: 1;
}

@keyframes cn-ai-dot-pulse {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/challenges/cn-ai-sidebar/cn-ai-sidebar.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA1YA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AA6YJ;AA3YI;EACI,mBAAA;AA6YR;AA3YQ;EACI,wBAAA;AA6YZ;AA1YQ;EACI,UAAA;EACA,mBAAA;AA4YZ;AAxYI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;EACA,6BAAA;EACA,oBAAA;AA0YR;AAvYI;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,YAxCQ;EAyCR,eAAA;EACA,YAAA;EACA,gBAAA;EACA,2CAAA;EACA,2BAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,UAAA;AAyYR;AAtYI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBDjBc;ECkBd,cAAA;AAwYR;AArYI;EACI,eAAA;EACA,gBAAA;EACA,cD3Ba;EC4Bb,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wEDvEK;AC8cb;AArYQ;EACI,cDlCS;ACyarB;AAnYI;EACI,eAAA;EACA,mBDrCc;ECsCd,cD9Ca;EC+Cb,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAqYR;AAlYI;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WDpDY;ECqDZ,eAAA;EACA,gBAAA;EACA,2BAAA;AAoYR;AAlYQ;EACI,cD5DS;ACgcrB;AAhYI;EACI,kBAAA;EACA,gCAAA;AAkYR;AA/XI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cD9Ea;EC+Eb,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wEDrHK;ACsfb;AA9XI;EACI,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,wED9HK;EC+HL,cDvFa;ECwFb,gBAAA;EACA,gBAAA;EACA,kCAAA;AAgYR;AA9XQ;EACI,qBD7FS;EC8FT,aAAA;EACA,yCAAA;AAgYZ;AA5XI;EACI,aAAA;EACA,QAAA;EACA,gBAAA;AA8XR;AA3XI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;EACA,wED5JK;ACyhBb;AA3XQ;EACI,mCDxII;ECyIJ,WAAA;AA6XZ;AA3XY;EACI,yBD3HK;ACwfrB;AA1XY;EACI,YAAA;EACA,mBAAA;AA4XhB;AAxXQ;EACI,mCDtJI;ECuJJ,WAAA;AA0XZ;AAxXY;EACI,yBDzIK;ACmgBrB;AAtXQ;EACI,6BAAA;EACA,cDpJS;ECqJT,sBAAA;AAwXZ;AAtXY;EACI,yBDhJM;ACwgBtB;AAnXI;EACI,kBAAA;EACA,mBAAA;EACA,cDpJI;ECqJJ,eAAA;EACA,6BAAA;EACA,wEDtMK;AC2jBb;AAnXQ;EACI,iBAAA;AAqXZ;AAjXI;EACI,kBAAA;EACA,kBAAA;EACA,WDtKY;ACyhBpB;AAjXQ;EACI,gBAAA;EACA,eAAA;EACA,cDlLS;ACqiBrB;AA/WI;EACI,aAAA;EACA,uBAAA;EACA,QAAA;AAiXR;AA/WQ;EACI,UAAA;EACA,WAAA;EACA,mBDzLS;EC0LT,kBAAA;EACA,6CAAA;AAiXZ;AA/WY;EACI,qBAAA;AAiXhB;AA9WY;EACI,qBAAA;AAgXhB;AA3WI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AA6WR;AA1WI;EACI,gBAAA;EACA,YAAA;EACA,cDtNa;ECuNb,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA4WR;AA1WQ;EACI,0BAAA;AA4WZ;AAxWI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AA0WR;AAvWI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,cD7Oa;ACslBrB;AAvWQ;EACI,qBDhPS;ECiPT,mBD9OU;ACulBtB;AAtWQ;EACI,+BDtQI;ECuQJ,oCAAA;AAwWZ;AArWQ;EACI,eAAA;EACA,cAAA;EACA,+BD7QI;AConBhB;AAnWI;EACI,OAAA;AAqWR;;AAjWA;EACI;IACI,qBAAA;IACA,YAAA;EAoWN;EAlWE;IACI,mBAAA;IACA,UAAA;EAoWN;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n$sidebar-width: 420px;\n$transition-speed: 0.3s;\n\n.cn-ai-sidebar {\n    position: fixed;\n    top: 0;\n    right: 0;\n    height: 100%;\n    z-index: 9998;\n    pointer-events: none;\n\n    &--open {\n        pointer-events: all;\n\n        .cn-ai-sidebar__panel {\n            transform: translateX(0);\n        }\n\n        .cn-ai-sidebar__overlay {\n            opacity: 1;\n            pointer-events: all;\n        }\n    }\n\n    &__overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(0, 0, 0, 0.3);\n        opacity: 0;\n        transition: opacity $transition-speed ease;\n        pointer-events: none;\n    }\n\n    &__panel {\n        position: fixed;\n        top: 0;\n        right: 0;\n        width: $sidebar-width;\n        max-width: 90vw;\n        height: 100%;\n        background: #fff;\n        box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n        transform: translateX(100%);\n        transition: transform $transition-speed ease;\n        display: flex;\n        flex-direction: column;\n        overflow-y: auto;\n        z-index: 1;\n    }\n\n    &__header {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 14px 20px;\n        border-bottom: 1px solid $color-grey-1;\n        background: $color-neutral-light;\n        flex-shrink: 0;\n    }\n\n    &__title {\n        font-size: 15px;\n        font-weight: 700;\n        color: $color-neutral-dark;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-family: $font-stack;\n\n        i {\n            color: $color-neutral-dark;\n        }\n    }\n\n    &__step-badge {\n        font-size: 11px;\n        background: $color-neutral-light;\n        color: $body-content-color;\n        padding: 3px 10px;\n        border-radius: 3px;\n        font-weight: 600;\n        white-space: nowrap;\n        border: 1px solid $clrDarkGray1;\n    }\n\n    &__close {\n        margin-left: auto;\n        background: none;\n        border: none;\n        font-size: 18px;\n        color: $color-neutral-mid;\n        cursor: pointer;\n        padding: 4px 8px;\n        transition: color 0.3s ease;\n\n        &:hover {\n            color: $color-neutral-dark;\n        }\n    }\n\n    &__section {\n        padding: 16px 20px;\n        border-bottom: 1px solid $color-grey-1;\n    }\n\n    &__label {\n        display: block;\n        font-size: 12px;\n        font-weight: 700;\n        color: $body-content-color;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        margin-bottom: 8px;\n        font-family: $font-stack;\n    }\n\n    &__prompt {\n        width: 100%;\n        padding: 10px 12px;\n        border: 1px solid $clrDarkGray1;\n        border-radius: 3px;\n        font-size: 13px;\n        font-family: $font-stack;\n        color: $color-neutral-dark;\n        resize: vertical;\n        min-height: 80px;\n        transition: border-color 0.3s ease;\n\n        &:focus {\n            border-color: $color-neutral-dark;\n            outline: none;\n            box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);\n        }\n    }\n\n    &__actions {\n        display: flex;\n        gap: 8px;\n        margin-top: 12px;\n    }\n\n    &__btn {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        padding: 7px 16px;\n        border: none;\n        border-radius: 3px;\n        font-size: 14px;\n        font-weight: 700;\n        cursor: pointer;\n        transition: background-color 0.3s ease;\n        font-family: $font-stack;\n\n        &--generate {\n            background-color: $develop-color;\n            color: #fff;\n\n            &:hover:not(:disabled) {\n                background-color: $color-neutral-dark;\n            }\n\n            &:disabled {\n                opacity: 0.5;\n                cursor: not-allowed;\n            }\n        }\n\n        &--add {\n            background-color: $develop-color;\n            color: #fff;\n\n            &:hover {\n                background-color: $color-neutral-dark;\n            }\n        }\n\n        &--regen {\n            background-color: transparent;\n            color: $body-content-color;\n            border: 1px solid $clrDarkGray1;\n\n            &:hover {\n                background-color: $color-neutral-light;\n            }\n        }\n    }\n\n    &__error {\n        padding: 12px 20px;\n        background: #fff3f3;\n        color: $color-red;\n        font-size: 13px;\n        border-bottom: 1px solid #fdd;\n        font-family: $font-stack;\n\n        i {\n            margin-right: 6px;\n        }\n    }\n\n    &__loading {\n        padding: 40px 20px;\n        text-align: center;\n        color: $color-neutral-mid;\n\n        p {\n            margin-top: 12px;\n            font-size: 13px;\n            color: $body-content-color;\n        }\n    }\n\n    &__loading-dots {\n        display: flex;\n        justify-content: center;\n        gap: 6px;\n\n        span {\n            width: 8px;\n            height: 8px;\n            background: $color-neutral-dark;\n            border-radius: 50%;\n            animation: cn-ai-dot-pulse 1.2s ease infinite;\n\n            &:nth-child(2) {\n                animation-delay: 0.2s;\n            }\n\n            &:nth-child(3) {\n                animation-delay: 0.4s;\n            }\n        }\n    }\n\n    &__results-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 8px;\n    }\n\n    &__select-all {\n        background: none;\n        border: none;\n        color: $body-content-color;\n        font-size: 12px;\n        cursor: pointer;\n        padding: 2px 6px;\n        font-weight: 700;\n\n        &:hover {\n            text-decoration: underline;\n        }\n    }\n\n    &__results {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n    }\n\n    &__result {\n        display: flex;\n        align-items: flex-start;\n        gap: 10px;\n        padding: 12px;\n        border: 1px solid $clrDarkGray1;\n        border-radius: 3px;\n        cursor: pointer;\n        transition: all 0.15s ease;\n        font-size: 13px;\n        line-height: 1.5;\n        color: $color-neutral-dark;\n\n        &:hover {\n            border-color: $color-neutral-dark;\n            background: $color-neutral-light;\n        }\n\n        &--selected {\n            border-color: $develop-color;\n            background: rgba($develop-color, 0.06);\n        }\n\n        input[type=\"checkbox\"] {\n            margin-top: 2px;\n            flex-shrink: 0;\n            accent-color: $develop-color;\n        }\n    }\n\n    &__result-text {\n        flex: 1;\n    }\n}\n\n@keyframes cn-ai-dot-pulse {\n    0%, 80%, 100% {\n        transform: scale(0.6);\n        opacity: 0.4;\n    }\n    40% {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
